export default [
    {
        path: 'relatorio-inconsistencia',
        component: () => import(/* webpackChunkName: 'raas-relatorio-inconsistencia' */ '@/views/raas/relatorio-inconsistencia/Index'),
        redirect: 'relatorio-inconsistencia/index',
        children: [
            {
                name: 'raas-relatorio-inconsistencia-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'raas-relatorio-inconsistencia' */ '@/views/raas/relatorio-inconsistencia/List.vue'),
            },
        ],
    },
]